import {
  SET_LOGIN_AUTH,
  SET_PATIENT_LOGIN_AUTH,
  SET_LOGOUT_AUTH,
  SET_PATIENT_LOGOUT_AUTH,
  FETCH_USER_INFO,
  PATIENT_DETAILS,
  INITIALIZE_APP,
  INITIALIZE_PATIENT_APP,
  IMPERSONATE_USER_REFRESH_ACKNOWLEDGEMENT,
  IMPERSONATE_VIEW_ENABLED,
  LOGIN_ERROR_MESSAGE,
  SET_SELECTED_PREFETCH_CASES,
  REMOVE_SELECTED_PREFETCH_CASE
} from '../actions/Index';

// Defining the initial state for the reducer
const initState = {
  authToken: null,
  patientAuthToken: null,
  initialRoute: '',
  isEnrolledForBioAuth: false,
  deviceHasTouchId: false,
  deviceHasFaceId: false,
  oauth: null,
  isImpersonateUserRefreshed: false,
  isImpersonateViewEnabled: false,
  impersonateUserName: '',
  userInfo: null,
  errorReason: null,
  selectedPrefetchCases: [],

};

export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case SET_LOGIN_AUTH:
      return {
        ...state,
        authToken: payload.authToken,
        initialRoute: payload.initialRoute || '',
        oauth: payload.oauth
      };
    case SET_PATIENT_LOGIN_AUTH:
      return {
        ...state,
        patientAuthToken: payload.authToken,
        initialRoute: payload.initialRoute || '',
        oauth: payload.oauth
      };
    case FETCH_USER_INFO: {
      return {
        ...state,
        userInfo: payload
      };
    }
    case LOGIN_ERROR_MESSAGE: {
      return {
        ...state,
        errorReason: payload.error
      };
    }
    case PATIENT_DETAILS: {
      return {
        ...state,
        firstName: payload.firstName,
        lastName: payload.lastName,
        dos: payload.dos,
        surgeon: payload.surgeon,
        patientId: payload.patientId
      };
    }
    case IMPERSONATE_USER_REFRESH_ACKNOWLEDGEMENT:
      return {
        ...state,
        isImpersonateUserRefreshed: payload.isImpersonateUserRefreshed
      };
    case IMPERSONATE_VIEW_ENABLED:
      return {
        ...state,
        isImpersonateViewEnabled: payload.isImpersonateViewEnabled,
        impersonateUserName: payload.impersonateUserName
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState,
        isEnrolledForBioAuth: state.isEnrolledForBioAuth,
        deviceHasTouchId: state.deviceHasTouchId,
        deviceHasFaceId: state.deviceHasFaceId,
        oauth: null
      };
    case SET_PATIENT_LOGOUT_AUTH:
      return {
        ...initState,
        isEnrolledForBioAuth: state.isEnrolledForBioAuth,
        deviceHasTouchId: state.deviceHasTouchId,
        deviceHasFaceId: state.deviceHasFaceId,
        oauth: null
      };
    case INITIALIZE_APP:
      return {...state, ...payload.config};
    case INITIALIZE_PATIENT_APP:
      return {...state, ...payload.config};
    case SET_SELECTED_PREFETCH_CASES:
      return { ...state, selectedPrefetchCases: action.payload };
    case REMOVE_SELECTED_PREFETCH_CASE:
      return {
        ...state,
        selectedPrefetchCases: state.selectedPrefetchCases.filter(
          (c: any) => c.case_pid !== action.payload
        ),
      };
    default:
      return state;
      
  }
}
